import Tags from "../Tags/tags";

new Tags({
	scope: '[data-contentlist="scope"]',
	tags: '[data-contentlist="tags"]',
	items: '[data-contentlist="items"]',
	searchForm: '[data-contentlist="form"]',
	paginator: '[data-contentlist="paginator"]',
	tag: '[data-tag]',
});